import listTemplate from './views/list.tpl.html';
import detailsTemplate from './views/details.tpl.html';
import editTemplate from './views/editor.tpl.html';

angular
    .module('festzelt-os.modules.bo.options')
    .config([
        '$stateProvider',
        config
    ]);

function config($stateProvider) {
    $stateProvider
        .state('app.bo.options', {
            abstract: true,
            url: 'objects/{objectId}/options',
            template: '<ui-view/>',
        })
        .state('app.bo.options.index', {
            url: '/',
            sticky: true,
            data: {
                rights: 'bookable_objects::option_list',
            },
            templateUrl: listTemplate,
            controller: 'BoOptionsListController',
            controllerAs: 'vm'
        })
        .state('app.bo.options.details', {
            url: '/{id}',
            data: {
                rights: 'bookable_objects::option_view',
            },
            templateUrl: detailsTemplate,
            controller: 'BoOptionDetailsController',
            controllerAs: 'vm'
        })
        .state('app.bo.options.edit', {
            url: '/{id}/edit',
            data: {
                rights: 'bookable_objects::option_edit',
            },
            templateUrl: editTemplate,
            controller: 'BoOptionEditController',
            controllerAs: 'vm'
        })
        .state('app.bo.options.create', {
            url: '/create',
            data: {
                rights: 'bookable_objects::option_create',
            },
            templateUrl: editTemplate,
            controller: 'BoOptionCreateController',
            controllerAs: 'vm'
        });
}



// WEBPACK FOOTER //
// ./src/app/modules/bo/options/routes.js